import React from "react";
import "./Card2.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import image from "./image.jpg";
import { Navigation, Pagination } from 'swiper/modules';
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const cardData = [
  {
    id: 1,
    name: "Jess Wilson",
    title: "UX Engineer",
    description: "Empowering users through captivating interfaces, turning ideas into pixel-perfect realities.",
    image: image,
  },
  {
    id: 1,
    name: "Jess Wilson",
    title: "UX Engineer",
    description: "Empowering users through captivating interfaces, turning ideas into pixel-perfect realities.",
    image: image,
  },
  {
    id: 1,
    name: "Jess Wilson",
    title: "UX Engineer",
    description: "Empowering users through captivating interfaces, turning ideas into pixel-perfect realities.",
    image: image,
  },
  {
    id: 1,
    name: "Jess Wilson",
    title: "UX Engineer",
    description: "Empowering users through captivating interfaces, turning ideas into pixel-perfect realities.",
    image: image,
  },
  // Add more card data here
];

export const Card2 = () => {
  const handleProfile = () => {
    // goto profile
  };

  const handleFollow = () => {
    // follow account
  };

  return (
    <div className="container sfddsd">
      <Swiper
        spaceBetween={20}
        slidesPerView={2}
        pagination={{ clickable: true }}
        navigation
        modules={[Navigation, Pagination]}
      >
        {cardData.map((card) => (
          <SwiperSlide key={card.id}>
           <div className="col-lg-6">
           <div className="card-2">
              <img src={card.image} alt={card.name} />
              <div>
                <h2>{card.name}</h2>
                <h3>{card.title}</h3>
                <p>{card.description}</p>
                <div className="buttons">
                  <button onClick={handleProfile}>Profile</button>
                  <button onClick={handleFollow} className="primary">
                    Follow
                  </button>
                </div>
              </div>
            </div>
           </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
